var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_3892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.019 43H13.981C9.029 43 5 38.971 5 34.019V13.981C5 9.029 9.029 5 13.981 5H34.018C38.971 5 43 9.029 43 13.981V34.018C43 38.971 38.971 43 34.019 43ZM13.981 7C12.1303 7.00238 10.356 7.73864 9.04732 9.04732C7.73864 10.356 7.00238 12.1303 7 13.981V34.018C7 37.868 10.132 41 13.981 41H34.018C37.868 41 41 37.868 41 34.019V13.981C40.9976 12.1303 40.2614 10.356 38.9527 9.04732C37.644 7.73864 35.8697 7.00238 34.019 7H13.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17C16.1046 17 17 16.1046 17 15C17 13.8954 16.1046 13 15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V35H14V20ZM34 35H32V27.529C32 23.688 29.825 22.883 28 22.883L23 22.981V35H21V21.02L27.98 20.883H27.981C29.409 20.883 34 21.363 34 27.529V35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_3892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.d36466d3758dc40d5c5a42e0f3539524.svg";
export { ForwardRef as ReactComponent };